import React from "react";
import { Container, Row, Col, Carousel } from 'react-bootstrap';
import HRG from '../../../Images/About/HRG.jpg';
import './About.css'; // Import your CSS file for custom styling

function About() {
  return (
    <div className="about-container">
      <h2 className="about-title">About Us</h2>
      <Container>
        <Row>
          <Col lg={5}>
            <img className="about-image" src={HRG} alt="HRG" />
          </Col>
          <Col lg={7}>
            <Carousel className="about-carousel" indicators={false} prevLabel="" nextLabel="">
              <Carousel.Item>
                <p className="about-text">
                  Gran means great, outstanding, and superior. At Gran Asia, we aim to represent the greatness of Asia and provide superior healthcare services for a better life.
                </p>
                <p className="about-text">
                  Our vision is to grow together and establish ourselves as an idol in the health industry, representing the greatness of Asia for a better life.
                </p>
                <p className="about-text">
                  In Asian countries like India, there is a tradition to give a taste of gold to newborn babies for their healthy and happy life. Gold is superior in all metals.
                </p>
                <p className="about-text">
                  In Greek mythology, Asia is a daughter of Oceanus and Tethys. Asia is also the mother of, among others, Atlas and Prometheus.
                </p>
                <p className="about-text">
                  Asia is the largest and most populous continent, covering 30% of the Earth's total land area. It was the birthplace of the world's mainstream religions and the site of the first civilization.
                </p>
                <p className="about-text">
                  Asia varies greatly across and within its regions with regard to ethnic groups, cultures, environment, economics, historical ties, different climates, and government systems.
                </p>
                <p className="about-text">
                  We aim to represent great, outstanding, and superior Asia for its healthy and happy life. It means a better life, as our name indicates, Gran Asia.
                </p>
                <strong className="about-text" style={{ color: '#015F8E' }}>'' YOU ARE COMMITTED TOGETHER FOR A BETTER LIFE''</strong>
              </Carousel.Item>
              <Carousel.Item>
                <h3 className="about-title">Our Vision</h3>
                <p className="about-text">
                Our vision is to grow together and we want to establish ourselves as an 'idol' in the health industry, representing Great Asia for a better life.
                </p>
                <h3 className="about-title">Our Mission</h3>
                <p className="about-text">
                  Our mission is to work together as a company with our doctors, for our people as a family. We strive to provide the best healthcare services for their health and happiness, maintaining high standards of ethics and social responsibility.
                </p>
                <h3 className="about-title">Our Values</h3>
                <ul className="about-values">
                  <li><strong>Humanity:</strong> Humanity should be ahead of everything.</li>
                  <li><strong>Ethics:</strong> Business with transparency and diligence.</li>
                  <li><strong>Quality:</strong> Quality should be the result of intelligent effort.</li>
                  <li><strong>Innovation:</strong> For the key to everything the future can be.</li>
                  <li><strong>Excellence:</strong> To be recognized as the best.</li>
                  <li><strong>Teamwork:</strong> For maintaining the highest standards of personal and corporate.</li>
                </ul>
              </Carousel.Item>
            </Carousel>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default About;
